import { forwardRef } from 'react';

import { ButtonBase } from './Defaults';

import type { ButtonBaseProps } from './Defaults';

export type SecondaryActionProps = Exclude<ButtonBaseProps, 'color'> & { readonly label: string };

export const SecondaryActionButton = forwardRef<HTMLButtonElement, SecondaryActionProps>((props, ref) => {
    const { fullWidth = false, label, variant, ...rest } = props;

    return (
        <ButtonBase
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
            ref={ref}
            aria-label={props['aria-label']}
            color="secondary"
            fullWidth={fullWidth}
            variant={variant ?? 'text'}
        >
            {label}
        </ButtonBase>
    );
});
